'use client';

import { Link } from 'react-router-dom';
import { PageSEO } from '@/seo/PageSEO';
import { IconArrowRight } from '@/components/Icons/Icons';
import styles from './BlogList.module.css';

type BlogPost = {
  slug: string;
  title: string;
  description: string;
  excerpt: string;
  date: string;
  category: string;
  image: string;
  readTime: string;
};

const blogPosts: BlogPost[] = [
  {
    slug: 'blog-bondex-sunger',
    title: 'Bondex Sünger Nedir? 2025 Rehberi: Kullanım Alanları, Fiyatları ve Uygulama Önerileri',
    description:
      'Bondex sünger nedir? Rebonded süngerpan teknolojisiyle üretilen Bondex sünger, ses yalıtımı ve titreşim sönümleme projelerinde nasıl kullanılır? Bondex sünger fiyatları, kalınlık seçenekleri (10mm, 20mm, 30mm, 40mm, 50mm) ve uygulama detayları hakkında kapsamlı rehber.',
    excerpt:
      'Bondex sünger, rebonded süngerpan olarak da bilinen, parçacık süngerlerin preslenmesiyle üretilen yüksek yoğunluklu bir sünger türüdür. Ses yalıtımı, darbe sönümleme, titreşim azaltma ve zemin/duvar detaylarında destek malzemesi olarak kullanılır. İnşaat sektöründe özellikle ses yalıtımı projelerinde sıkça tercih edilen bu malzeme, rebonded teknolojisi sayesinde yüksek performans sunar. Türkiye\'de özellikle stüdyo, ofis, endüstriyel tesis ve konut projelerinde kullanılan Bondex sünger, farklı kalınlık seçenekleriyle proje ihtiyacına göre uyarlanabilir...',
    date: '2025-12-26',
    category: 'Ses Yalıtımı',
    image: '/images/bondex-sunger.webp',
    readTime: '8 dakika',
  },
  {
    slug: 'blog-bariyerli-bondex-sunger',
    title: 'Bariyerli Bondex Sünger Nedir? 2025 Rehberi: Avantajları, Fiyatları ve Uygulama Detayları',
    description:
      'Bariyerli Bondex sünger nedir? Bondex sünger ile bariyer katmanının birleştiği kompozit çözüm. Bariyerli Bondex 23mm, 33mm, 43mm, 53mm kalınlık seçenekleri, fiyatları ve uygulama önerileri hakkında kapsamlı rehber.',
    excerpt:
      'Bariyerli Bondex; Bondex sünger ile ses bariyeri katmanının birleştiği, ses geçişini azaltmaya odaklı kompozit bir çözümdür. Bariyer katmanı sayesinde hava kaynaklı ses geçişini azaltmaya yardımcı olur ve uygulamaya göre performans artışı sağlar. Daha yüksek izolasyon gerektiren projelerde klasik Bondex süngere göre daha etkili sonuçlar verir. Özellikle komşu daireler arası ses geçişini önlemede, profesyonel stüdyo uygulamalarında ve yüksek ses seviyeli ortamlarda tercih edilir. 23mm, 33mm, 43mm ve 53mm kalınlık seçenekleriyle farklı proje ihtiyaçlarına cevap verir...',
    date: '2025-12-26',
    category: 'Ses Yalıtımı',
    image: '/images/Bariyerli-bondex.webp',
    readTime: '7 dakika',
  },
  {
    slug: 'blog-cift-bariyerli-bondex',
    title: 'Çift Bariyerli Bondex Sünger Nedir? 2025 Rehberi: Premium İzolasyon Çözümü',
    description:
      'Çift Bariyerli Bondex nedir? İki bariyer katmanıyla maksimum izolasyon sağlayan premium kompozit çözüm. Çift Bariyerli Bondex 26mm, 36mm, 46mm, 56mm kalınlık seçenekleri, fiyatları ve uygulama detayları.',
    excerpt:
      'Çift Bariyerli Bondex; iki bariyer katmanıyla premium maksimum izolasyon hedefleyen kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sağlar. Premium projelerde, maksimum ses yalıtımı gerektiren alanlarda ve özel uygulamalarda tercih edilir. İki bariyer katmanı sayesinde hava kaynaklı ses geçişini maksimum seviyede azaltır. 26mm, 36mm, 46mm ve 56mm kalınlık seçenekleriyle kompakt çözümlerden maksimum performanslı uygulamalara kadar geniş bir yelpazede kullanılabilir...',
    date: '2025-12-26',
    category: 'Ses Yalıtımı',
    image: '/images/cift-bariyerli-bondex-26mm.webp',
    readTime: '6 dakika',
  },
];

export function BlogList() {
  return (
    <>
      <PageSEO
        title="Blog | Bondex Sünger - Ses Yalıtımı Rehberleri ve Uygulama Önerileri"
        description="Bondex sünger, Bariyerli Bondex ve Çift Bariyerli Bondex hakkında detaylı rehberler, uygulama önerileri, fiyat bilgileri ve teknik detaylar. Ses yalıtımı projeleriniz için kapsamlı blog yazıları."
        pathname="/blog"
      />
      <main className={styles.blogListPage}>
        <div className="container">
          <header className={styles.blogListHeader}>
            <nav className={styles.breadcrumb} aria-label="Breadcrumb">
              <Link to="/">Anasayfa</Link>
              <span> / </span>
              <span>Blog</span>
            </nav>
            <h1 className={styles.blogListTitle}>Blog</h1>
            <p className={styles.blogListDescription}>
              Bondex sünger, Bariyerli Bondex ve Çift Bariyerli Bondex hakkında detaylı rehberler, uygulama önerileri,
              fiyat bilgileri ve teknik detaylar. Ses yalıtımı projeleriniz için kapsamlı içerikler.
            </p>
          </header>

          <div className={styles.blogGrid}>
            {blogPosts.map((post) => (
              <article key={post.slug} className={styles.blogCard}>
                <Link to={`/${post.slug}`} className={styles.blogCardLink}>
                  <div className={styles.blogCardImage}>
                    <img src={post.image} alt={post.title} loading="lazy" />
                    <div className={styles.blogCardCategory}>{post.category}</div>
                  </div>
                  <div className={styles.blogCardContent}>
                    <div className={styles.blogCardMeta}>
                      <time dateTime={post.date} className={styles.blogCardDate}>
                        {new Date(post.date).toLocaleDateString('tr-TR', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        })}
                      </time>
                      <span className={styles.blogCardReadTime}>{post.readTime} okuma</span>
                    </div>
                    <h2 className={styles.blogCardTitle}>{post.title}</h2>
                    <p className={styles.blogCardExcerpt}>{post.excerpt}</p>
                    <div className={styles.blogCardFooter}>
                      <span className={styles.blogCardReadMore}>
                        Devamını Oku <IconArrowRight />
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          <section className={styles.blogCtaSection}>
            <h2 className={styles.blogCtaTitle}>Ürünlerimizi İnceleyin</h2>
            <p className={styles.blogCtaDescription}>
              Blog yazılarımızda bahsettiğimiz ürünleri inceleyin, kalınlık seçeneklerini karşılaştırın ve fiyat teklifi alın.
            </p>
            <div className={styles.blogCtaButtons}>
              <Link className="btn btnPrimary" to="/urunler">
                Tüm Ürünler
              </Link>
              <Link className="btn" to="/bondex-sunger">
                Bondex Sünger
              </Link>
              <Link className="btn" to="/bariyerli-bondex-sunger">
                Bariyerli Bondex
              </Link>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}

